import { AxiosInstance } from 'axios';
import { setAxiosAuthInterceptor } from 'samolet-oauth2';

export const initializeAuth = (instance: AxiosInstance) => {
  if (__USE_AUTH_TYPE__ === 'SESSION') {
    instance.interceptors.response.use(
      response => response,
      error => {
        if (error.response?.status === 401) {
          window.location.href = '/auth';
          return;
        }

        return Promise.reject(error);
      },
    );
  } else {
    setAxiosAuthInterceptor(instance, {
      clientId: __SAMOLET_OAUTH2_PKCE_CLIENT_ID__,
    });
  }
};
